import React, { Fragment } from 'react'

const About = () => {
    return (
        <Fragment>
            <h1>A web app to search for github users</h1>
            <h3>App version 1.0.0</h3>
            <p>Built by MufasaToday</p>
        </Fragment>
    )
}

export default About;
